import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { Form, Row, Col, Container, Button } from "react-bootstrap";
import creditCardType from "credit-card-type";
import styled from "styled-components";
import { toAbsoluteUrl } from "../../helpers/Utils";

import texts from "./utils/langMessage";
import { Flex, Input, Typography } from "antd";
import { PoweroffOutlined, SyncOutlined } from "@ant-design/icons";
import setting from "../../services/setting";
import { toastError } from "./utils/toastNotifications";
const { Title } = Typography;

const inputStyle = {
  width: "100%",
  height: "34px",
  borderRadius: "8px",
};

const StyledWrapper1 = styled.div`
  .flip-card-container {
    perspective: 1000px;
    width: 100%;
    height: 100%;
  }

  .flip-card-inner {
    width: 100%;
    height: 100%;
    transition: transform 0.6s ease;
  }

  .flipped {
    transform: rotateY(180deg); /* เมื่อกดให้หมุน */
  }
`;

const CardText = styled.span`
  font-size: 26px;

  @media (max-width: 1200px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;




const formatCardNumber = (number, gaps) => {
  let formattedValue = number;
  gaps.forEach((gap, index) => {
    if (formattedValue.length > gap + index) {
      formattedValue =
        formattedValue.slice(0, gap + index) +
        " " +
        formattedValue.slice(gap + index);
    }
  });
  return formattedValue;
};

// กำหนดปีปัจจุบันและจำนวนปีในอนาคตที่ต้องการ
const currentYear = new Date().getFullYear(); // ปีปัจจุบัน
const futureYearsCount = 10; // จำนวนปีในอนาคตที่ต้องการแสดง

// สร้างรายการปี
const years = Array.from({ length: futureYearsCount }, (_, index) => {
  const year = currentYear + index;
  return {
    value: year.toString().slice(-2), // คืนมาเป็นเลขสองหลัก เช่น "25", "26"
    label: year.toString(), // แสดงเป็นปีเต็ม เช่น "2025", "2026"
  };
});

const months = [
  { value: "01", label: "01" },
  { value: "02", label: "02" },
  { value: "03", label: "03" },
  { value: "04", label: "04" },
  { value: "05", label: "05" },
  { value: "06", label: "06" },
  { value: "07", label: "07" },
  { value: "08", label: "08" },
  { value: "09", label: "09" },
  { value: "10", label: "10" },
  { value: "11", label: "11" },
  { value: "12", label: "12" },
];

const PaymentForm = ({
  paymentData,
  setPaymentData,
  paymentMethod,
  paymentEmail,
  confirmPayment,
  setPaymentMethod,
  selectCreditBank,
  setConfirmPayment,
  setPaymentEmail,
  setIsPaymentEmailVerified,
  BASE_URL,
  lang,
}) => {

  ///////////////////STYLE/////////////////////

  const isSmallScreen = useMediaQuery({ maxWidth: 576 });
  const isTabletScreen = useMediaQuery({ minWidth: 577, maxWidth: 768 });
  const isMediumScreen = useMediaQuery({ minWidth: 992, maxWidth: 1024 });
  const isLargeScreen = useMediaQuery({ minWidth: 1440 });

  ///LOGO ประเเถทบัตร ด้านหน้า
  const Front_logoPositionStyle = {
    width: isSmallScreen
      ? "55px"
      : isTabletScreen
      ? "65px"
      : isMediumScreen
      ? "75px"
      : isLargeScreen
      ? "85px"
      : "89px",
  
    height: isSmallScreen
      ? "35px"
      : isTabletScreen
      ? "40px"
      : isMediumScreen
      ? "48px"
      : isLargeScreen
      ? "52px"
      : "55px",
  
    bottom: isSmallScreen
      ? "7.3%"
      : isTabletScreen
      ? "7.2%"
      : isMediumScreen
      ? "7.1%"
      : "7%", // default for large and beyond
  
    right: isSmallScreen
      ? "7.3%"
      : isTabletScreen
      ? "7.2%"
      : isMediumScreen
      ? "7.1%"
      : "7%",
  
    position: "absolute",
    textAlign: "center",
  };


  const Back_logoPositionStyle = {
    width: isSmallScreen
      ? "55px"
      : isTabletScreen
      ? "65px"
      : isMediumScreen
      ? "75px"
      : isLargeScreen
      ? "90px"
      : "90px",
  
    height: isSmallScreen
      ? "35px"
      : isTabletScreen
      ? "42px"
      : isMediumScreen
      ? "50px"
      : isLargeScreen
      ? "54px"
      : "56px",
  
    bottom: isSmallScreen
      ? "30%"
      : isTabletScreen
      ? "29%"
      : isMediumScreen
      ? "25%"
      : "30%", // default
  
    right: isSmallScreen
      ? "5.8%"
      : isTabletScreen
      ? "5.5%"
      : isMediumScreen
      ? "5.3%"
      : "5.2%",
  
    position: "absolute",
    textAlign: "center",
  };
  










  const visaLogo = toAbsoluteUrl("/media/paycard/credit_logo/visa-logo.png");
  const mastercardLogo = toAbsoluteUrl(
    "/media/paycard/credit_logo/master-logo.png"
  );
  const jcbLogo = toAbsoluteUrl("/media/paycard/credit_logo/jcb-logo.png");
  const amexLogo = toAbsoluteUrl("/media/paycard/credit_logo/amex-logo.png");

  //state
  const [issuerBank, setIssuerBank] = useState("");
  const [cardHolderName, setCardHolderName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryMonth, setExpiryMonth] = useState("");
  const [expiryYear, setExpiryYear] = useState("");
  const [cvv, setCvv] = useState("");

  ///////////////////////////////////////////////////////
  //////////////////////PIN-VERIFY///////////////////////
  ///////////////////////////////////////////////////////
  const [email, setEmail] = useState("");
  const [pinToken, setPinToken] = useState("");
  const [pinDigits, setPinDigits] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(0);
  const inputsRef = useRef([]);

  // Countdown timer
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  // ส่ง PIN
  const handleSendPin = async () => {
    if (!email) return alert("กรุณากรอกอีเมล");

    const res = await fetch(`${BASE_URL}/subscription/auth/send-pin`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();

    if (res.ok) {
      setPinToken(data.token);
      setCountdown(60); // เริ่มนับถอยหลัง 60 วินาที
      alert("ส่ง PIN ไปยังอีเมลแล้ว");
    } else {
      alert(data.message || "เกิดข้อผิดพลาด");
    }
  };

  // ยืนยัน PIN
  const handleVerifyPin = async () => {
    const pin = pinDigits.join("");
    if (pin.length !== 6) return alert("กรุณากรอก PIN ให้ครบ");

    const res = await fetch(`${BASE_URL}/subscription/auth/verify-pin`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: pinToken, pin }),
    });

    const data = await res.json();

    if (res.ok) {
      alert("✅ ยืนยันสำเร็จ สำหรับอีเมล: " + data.email);
      setIsPaymentEmailVerified(true);
    } else {
      alert(data.message || "PIN ไม่ถูกต้อง");
    }
  };

  // Auto focus ช่องถัดไป
  const handlePinChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newDigits = [...pinDigits];
    newDigits[index] = value;
    setPinDigits(newDigits);

    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !pinDigits[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  ///////////////////////////
  const onChange = (text) => {
    console.log("onChange:", text);
  };
  const onInput = (value) => {
    console.log("onInput:", value);
  };
  const sharedProps = {
    onChange,
    onInput,
  };

  const [loadings, setLoadings] = useState(false);

  const enterLoading = (index) => {
    setLoadings(true);

    setTimeout(() => {
      setLoadings(false);
    }, 3000);
  };

  ////////////////////////////
  useEffect(() => {
    setPaymentMethod({
      name: cardHolderName,
      number: cardNumber,
      expiration_month: expiryMonth,
      expiration_year: expiryYear,
      security_code: cvv,
    });
  }, [cardHolderName, cardNumber, expiryMonth, expiryYear, cvv]);

  useEffect(() => {
    if (!paymentMethod) return;

    console.log("paymentMethod", paymentMethod);

    setCardHolderName(paymentMethod.name || "");
    setCardNumber(paymentMethod.number || "");
    setExpiryMonth(paymentMethod.expiration_month || "");
    setExpiryYear(paymentMethod.expiration_year || "");
    setCvv(paymentMethod.security_code || "");
  }, []);

  //card format
  const gaps = paymentData?.[0]?.gaps || [4, 8, 12]; // ใช้ gaps จาก paymentData หากไม่มีจะใช้ default
  //const formattedCardNumber = formatCardNumber(cardNumber, gaps);

  const [isFlipped, setIsFlipped] = useState(true);

  const handleCardNumberChange = (value, selectionStart) => {
    const numericValue = value.replace(/\D/g, ""); // ลบตัวอักษรที่ไม่ใช่ตัวเลข
    const cardInfo = creditCardType(numericValue);

    if (numericValue.length > 0) {
      console.log("Card Type:", cardInfo[0]?.niceType || "Unknown"); // เช่น "Visa", "MasterCard"
      console.log("Card Code:", cardInfo[0]?.code?.name || "N/A"); // เช่น "CVV", "CVC"
      setPaymentData(cardInfo);
    } else {
      setPaymentData([]);
    }

    const gaps = cardInfo[0]?.gaps || [4, 8, 12]; // gaps จากประเภทบัตร
    let formattedValue = formatCardNumber(numericValue, gaps);

    // ตรวจสอบว่ากำลังลบอยู่หรือไม่ และหากอยู่ที่ตำแหน่งช่องว่างให้เลื่อนตำแหน่งเคอร์เซอร์
    if (value.length < cardNumber.length && gaps.includes(selectionStart - 1)) {
      formattedValue =
        formattedValue.slice(0, selectionStart - 2) +
        formattedValue.slice(selectionStart - 1);
    }

    setCardNumber(formattedValue); // อัปเดต state ด้วยค่าที่ฟอร์แมตแล้ว
  };

  const getBankLabel = (value) => {
    const labelKey = lang === "en" ? "label1" : "label2"; // ใช้ labelKey เพื่อกำหนด label ที่ต้องการ

    return (
      selectCreditBank.find((item) => item.value === value)?.[labelKey] ||
      "Unknown Bank"
    );
  };

  return (
    <Container className="">
      <Form className="p-4" style={{ color: "rgb(0, 0, 0)" }}>
        <div
          className="d-flex justify-content-end align-items-center flex-wrap"
          style={{ gap: "0px", padding: "0px" }}
        >
          {[
            { name: "american-express", logo: "amex-logo.png" },
            { name: "visa", logo: "visa-logo.png" },
            { name: "mastercard", logo: "master-logo.png" },
            { name: "jcb", logo: "jcb-logo.png" },
          ].map((item, index) => (
            <div
              key={index}
              data-name={item.name} // เพิ่ม name เป็น data attribute
              style={{
                width: "68px",
                height: "45px",
                backgroundImage: `url('/media/paycard/credit_logo/${item.logo}')`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                borderRadius: "8px",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                transform: "scale(0.7)", // ลดขนาดลงเหลือ 80%
                filter:
                  paymentData[0]?.type === undefined
                    ? "none"
                    : paymentData[0]?.type === item.name
                    ? "none"
                    : "grayscale(100%)", // กรณี undefined ให้แสดงสีปกติ
              }}
              alt={`${item.name} Credit Card Logo`}
              //onClick={(e) => alert(`Selected: ${e.currentTarget.dataset.name}`) }
            />
          ))}
        </div>
        {/* <h4 className="mb-4 font-weight-bold">Organization Information</h4> */}
        {/* Organization Name */}
        <Row className="mb-0">
          <Col sm={5} style={{ paddingRight: "10px" }}>
            <Form.Group className="flex-grow-1 mb-2">
              <Form.Label>Issuer Bank *</Form.Label>

              <Form.Select
                style={inputStyle}
                onChange={(e) => setIssuerBank(e.target.value)} // ส่งค่าที่ผู้ใช้กรอก
                onFocus={() => setIsFlipped(false)}
                value={paymentMethod.issuerBank} // กำหนดค่าเริ่มต้น
              >
                {selectCreditBank &&
                  selectCreditBank.map((item, index) => (
                    <option key={index} value={item.value}>
                      {lang === "en" ? item.label1 : item.label2}{" "}
                      {/* แสดง label ตามภาษา */}
                    </option>
                  ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="flex-grow-1 mb-2">
              <Form.Label>Card holder name *</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Card holder name"
                maxLength="26"
                style={inputStyle}
                onchange={(e) => setCardHolderName(e.target.value)} // ส่งค่าที่ผู้ใช้กรอก
                onFocus={() => setIsFlipped(false)}
                onChange={(e) => setCardHolderName(e.target.value)} // ส่งค่าที่ผู้ใช้กรอก
                value={cardHolderName || ""}
              />
            </Form.Group>
            <Form.Group className="flex-grow-1 mb-2">
              <Form.Label>Credit/debit card number *</Form.Label>
              <div style={{ position: "relative" }}>
                <Form.Control
                  type="text"
                  placeholder="Enter Credit/Debit Card Number"
                  style={{
                    ...inputStyle,
                    borderColor:
                      cardNumber !== "" && paymentData.length === 0
                        ? "red"
                        : "#ced4da", // เปลี่ยนสี border เป็นสีแดงเมื่อเลขบัตรผิด
                  }}
                  value={cardNumber ? cardNumber : ""}
                  maxLength={
                    Math.max(...(paymentData[0]?.lengths || [16])) +
                    (paymentData[0]?.gaps?.length || 0)
                  }
                  onChange={(e) =>
                    handleCardNumberChange(
                      e.target.value,
                      e.target.selectionStart
                    )
                  }
                  onFocus={() => setIsFlipped(false)}
                />

                {/* แสดงไอคอนแจ้งเตือน */}
                {cardNumber !== "" && paymentData.length === 0 && (
                  <span
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "32%",
                      transform: "translateY(-50%)",
                      color: "red",
                      fontSize: "18px",
                    }}
                  >
                    ⚠️
                  </span>
                )}

                {/* แสดงข้อความแจ้งเตือน */}
                {cardNumber !== "" && paymentData.length === 0 && (
                  <Form.Text
                    className="text-danger"
                    style={{ marginTop: "5px" }}
                  >
                    Invalid card number. Please enter a valid credit/debit card
                    number.
                  </Form.Text>
                )}
              </div>
            </Form.Group>
            <Row className="mb-3 align-items-center">
              <Col sm={8}>
                <Row className="g-2">
                  <Col sm={6}>
                    <Form.Group className="flex-grow-1 mb-2">
                      <Form.Label>Month*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="MM"
                        style={inputStyle}
                        maxLength={2}
                        onChange={(e) => setExpiryMonth(e.target.value)} // ส่งค่าที่ผู้ใช้กรอก
                        onFocus={() => setIsFlipped(false)}
                        value={expiryMonth ? expiryMonth : ""}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={6}>
                    <Form.Group className="flex-grow-1 mb-2">
                      <Form.Label>Year*</Form.Label>
                      <Form.Control
                        type="text"
                        name="expiryYear"
                        placeholder="YY"
                        style={inputStyle}
                        maxLength={2}
                        onChange={(e) => setExpiryYear(e.target.value)} // ส่งค่าที่ผู้ใช้กรอก
                        onFocus={() => setIsFlipped(false)}
                        value={expiryYear ? expiryYear : ""}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col sm={4}>
                <Form.Group className="flex-grow-1 mb-2">
                  <Form.Label>CVV *</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="CVV"
                    name="cvv"
                    maxLength={paymentData[0]?.code?.size || 3} // จำกัดความยาวของข้อมูลที่กรอก
                    style={inputStyle}
                    onChange={(e) => setCvv(e.target.value)} // ส่งค่าที่ผู้ใช้กรอก
                    onFocus={() => setIsFlipped(true)}
                    onBlur={() => setIsFlipped(false)}
                    value={cvv ? cvv : ""}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Col>

          <Col xs={12} sm={7} className="p-2 " style={{ height: "auto" }}>
            <StyledWrapper1>
              <div
                className="flip-card-container"
                onClick={() => setIsFlipped(!isFlipped)} // พลิกการ์ดเมื่อคลิก
                style={{
                  perspective: "1000px", // ทำให้เกิดมุมมอง 3D
                  maxWidth: "100%",
                  height: "100%",
                  margin: "auto",
                }}
              >
                <div
                  className={`flip-card-inner ${isFlipped ? "flipped" : ""}`}
                  style={{
                    width: "100%",
                    aspectRatio: "16/10", // ✅ เพิ่มความสัมพันธ์ของความกว้าง/สูง
                    borderRadius: "20px",
                    position: "relative",
                    transition: "transform 0.6s",
                    transformStyle: "preserve-3d",
                    backfaceVisibility: "hidden",
                  }}
                >
                  {/* Front Card */}
                  <div
                    style={{
                      aspectRatio: "16/10",
                      width: "100%",
                      borderRadius: "20px",
                      backgroundImage: "url('/media/paycard/Front_Card.png')",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      position: "absolute",
                      backfaceVisibility: "hidden", // ซ่อนด้านหลังของการ์ด
                    }}
                  >
                    {/* // Bank Name-----------*/}
                    <div
                      style={{
                        position: "absolute",
                        top: "3%", // ปรับระยะห่างจากด้านล่าง
                        left: "3%", // ปรับระยะห่างจากด้านขวา
                        width: "auto",
                        textAlign: "center",
                        color: "white",
                        paddingX: "5px",
                        marginRight: "15px",
                        textAlign: "left",
                        // border: "1px solid red",
                      }}
                    >
                      <span
                        style={{
                          fontSize: isSmallScreen
                            ? "9px" // ขนาดฟอนต์สำหรับหน้าจอเล็ก
                            : isTabletScreen
                            ? "12px" // ขนาดฟอนต์สำหรับแท็บเล็ต
                            : isMediumScreen
                            ? "11px" // ขนาดฟอนต์สำหรับหน้าจอกลาง
                            : "14px",
                        }}
                      >
                        {getBankLabel(Number(issuerBank))}
                      </span>
                    </div>
                    {/* // Bank Name-----------*/}
                    {/* // แสดง เลขของบัตร------------*/}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "30%", // ปรับระยะห่างจากด้านล่าง
                        right: "20%", // ปรับระยะห่างจากด้านขวา
                        width: "auto",
                        textAlign: "center",
                        color: "white",

                        // border: "1px solid red",
                        paddingX: "10px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: isSmallScreen
                            ? "19px" // ขนาดฟอนต์สำหรับหน้าจอเล็ก
                            : isTabletScreen
                            ? "20px" // ขนาดฟอนต์สำหรับแท็บเล็ต
                            : isMediumScreen
                            ? "18px" // ขนาดฟอนต์สำหรับหน้าจอกลาง
                            : "25px",
                        }}
                      >
                        {cardNumber || "XXXX XXXX XXXX XXXX"}
                      </span>
                    </div>
                    {/* // แสดง เลขของบัตร------------*/}
                    {/* // Card holder name-----------*/}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "3%", // ปรับระยะห่างจากด้านล่าง
                        left: "5%", // ปรับระยะห่างจากด้านขวา
                        width: "auto",
                        textAlign: "center",
                        color: "white",
                        fontSize: isSmallScreen
                          ? "12px"
                          : isTabletScreen
                          ? "12px"
                          : "15px",
                        // border: "1px solid red",
                        paddingX: "5px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: isSmallScreen
                            ? "12px" // ขนาดฟอนต์สำหรับหน้าจอเล็ก
                            : isTabletScreen
                            ? "12px" // ขนาดฟอนต์สำหรับแท็บเล็ต
                            : isMediumScreen
                            ? "12px" // ขนาดฟอนต์สำหรับหน้าจอกลาง
                            : "16px",
                        }}
                      >
                        {cardHolderName || "FULL NAME"}
                      </span>
                    </div>
                    {/* // Card holder name-----------*/}
                    {/* // Exp date-----------*/}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "18%", // ปรับระยะห่างจากด้านล่าง
                        right: "39%", // ปรับระยะห่างจากด้านขวา
                        width: "auto",
                        textAlign: "center",
                        color: "white",
                        fontSize: isSmallScreen
                          ? "12px" // ขนาดฟอนต์สำหรับหน้าจอเล็ก
                          : isTabletScreen
                          ? "12px" // ขนาดฟอนต์สำหรับแท็บเล็ต
                          : isMediumScreen
                          ? "12px" // ขนาดฟอนต์สำหรับหน้าจอกลาง
                          : "16px",
                        paddingX: "5px",
                      }}
                    >
                      <span>
                        {(expiryMonth || "MM") + "/" + (expiryYear || "YY")}
                      </span>
                    </div>
                    {/* // Exp date-----------*/}
                    {/* // แสดง Logo ของบัตร  หน้าาาาา-----------*/}
                    <div
                      // style={{
                      //   width: isSmallScreen ? "55px" : "89px",
                      //   height: isSmallScreen ? "35px" : "55px",
                      //   position: "absolute",
                      //   bottom: isSmallScreen ? "7.3%" : "7%",
                      //   right: isSmallScreen ? "7.3%" : "7%",
                      //   textAlign: "center",
                      // }}
                      style={Front_logoPositionStyle}
                    >
                      <img
                        src={
                          paymentData[0]?.type === "visa"
                            ? visaLogo
                            : paymentData[0]?.type === "mastercard"
                            ? mastercardLogo
                            : paymentData[0]?.type === "jcb"
                            ? jcbLogo
                            : paymentData[0]?.type === "american-express"
                            ? amexLogo
                            : null
                        }
                        // alt="credit card logo"
                        style={{
                          width: "100%",
                          height: "100%",
                          //objectFit: "contain",
                          display:
                            !paymentData[0]?.type ||
                            !(
                              paymentData[0]?.type === "visa" ||
                              paymentData[0]?.type === "mastercard" ||
                              paymentData[0]?.type === "jcb" ||
                              paymentData[0]?.type === "american-express"
                            )
                              ? "none" // ไม่แสดงรูปถ้า type ไม่มีค่า
                              : "block",
                        }}
                      />
                    </div>
                    {/* // แสดง Logo ของบัตร------------*/}
                  </div>

                  {/* Back Card */}
                  <div
                    style={{
                      aspectRatio: "16/10",
                      width: "100%",
                      borderRadius: "20px",
                      backgroundImage: "url('/media/paycard/Bank_Card.png')",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      position: "absolute",
                      transform: "rotateY(180deg)", // หมุนด้านหลัง 180 องศา
                      backfaceVisibility: "hidden",
                    }}
                  >
                    {/* // แสดง Logo ของบัตร หลังงงง-----------*/}
                    <div
                      // style={{
                      //   width: isSmallScreen ? "55px" : "90px", // ✅ ย่อบนมือถือ
                      //   height: isSmallScreen ? "35px" : "56px",
                      //   position: "absolute",
                      //   bottom: isSmallScreen ? "30%" : "30%", // ✅ ย้ายขึ้นลงตามจอ
                      //   right: isSmallScreen ? "5.8%" : "5.2%",
                      //   textAlign: "center",
                      // }}
                      style={Back_logoPositionStyle}
                    >
                      <img
                        src={
                          paymentData[0]?.type === "visa"
                            ? visaLogo
                            : paymentData[0]?.type === "mastercard"
                            ? mastercardLogo
                            : paymentData[0]?.type === "jcb"
                            ? jcbLogo
                            : paymentData[0]?.type === "american-express"
                            ? amexLogo
                            : null
                        }
                        // alt="credit card logo"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          display:
                            !paymentData[0]?.type ||
                            !(
                              paymentData[0]?.type === "visa" ||
                              paymentData[0]?.type === "mastercard" ||
                              paymentData[0]?.type === "jcb" ||
                              paymentData[0]?.type === "american-express"
                            )
                              ? "none" // ไม่แสดงรูปถ้า type ไม่มีค่า
                              : "block",
                        }}
                      />
                    </div>
                    {/* // แสดง Logo ของบัตร------------*/}

                    {/* // แสดง CVV ของบัตร -----------*/}
                    <div
                      style={{
                        position: "absolute",
                        bottom: "50%", // ปรับระยะห่างจากด้านล่าง
                        right: "8%", // ปรับระยะห่างจากด้านขวา
                        width: "auto",
                        textAlign: "center",
                      }}
                    >
                      <span style={{ color: "black", fontSize: "18px" }}>
                        {"*".repeat(cvv.length) || ""}
                      </span>
                    </div>
                    {/* // แสดง Logo ของบัตร -----------*/}
                  </div>
                </div>
              </div>
            </StyledWrapper1>
          </Col>
        </Row>

        <Col
          xs={12}
          sm={12}
          className="p-2"
          style={{
            position: "relative",
            marginTop: "5px",
          }}
        >
          <h4 className="mt-8 mb-8">อีเมลสำหรับการชำระเงินครั้งถัดไป</h4>

          <div
            style={{
              display: "flex",
              flexDirection: isSmallScreen ? "column" : "row",
              gap: "10px",
              alignItems: isSmallScreen ? "stretch" : "center",
              marginBottom: "8px",
            }}
          >
            <input
              type="email"
              placeholder="กรอกอีเมลของคุณ"
              //style={{
              //  width: isSmallScreen ? "100%" : isTabletScreen ? "70%" : "50%",
              //  padding: "8px",
              //  fontSize: "16px",
              //  borderRadius: "4px",
              //  border: "1px solid #ccc",
              //}}
              style={{
                flex: "1",
                padding: "10px",
                fontSize: "16px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                minWidth: isSmallScreen ? "100%" : "250px",
              }}
              value={paymentEmail || ""}
              onChange={(e) => {
                setPaymentEmail(e.target.value);
                setEmail(e.target.value);
              }}
            />

            <Button
              onClick={handleSendPin}
              disabled={countdown > 0}
              style={{ width: isSmallScreen ? "100%" : "auto" }}
            >
              {countdown > 0 ? `ส่งได้อีกใน ${countdown} วินาที` : "ส่ง PIN"}
            </Button>
          </div>

          {pinToken && (
            <div style={{ marginTop: 20 }}>
              <p>กรุณากรอก PIN ที่ได้รับทางอีเมล</p>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: isSmallScreen ? "center" : "flex-start",
                  gap: "8px",
                }}
              >
                {pinDigits.map((digit, idx) => (
                  <input
                    key={idx}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handlePinChange(e.target.value, idx)}
                    onKeyDown={(e) => handleBackspace(e, idx)}
                    ref={(el) => (inputsRef.current[idx] = el)}
                    style={{
                      width: 40,
                      height: 40,
                      textAlign: "center",
                      fontSize: 20,
                    }}
                  />
                ))}
              </div>

              <Button onClick={handleVerifyPin} style={{ marginTop: 20 }}>
                ยืนยัน PIN
              </Button>
            </div>
          )}

          <div style={{ marginTop: 16 }}>
            <input
              type="checkbox"
              onChange={(e) => setConfirmPayment(e.target.checked)}
              checked={confirmPayment}
            />

            <span style={{ color: "red", fontSize: "14px", marginLeft: 8 }}>
              <Typography.Text type="danger">
                {texts[lang].payment_accept}
              </Typography.Text>
            </span>
          </div>
        </Col>
      </Form>
    </Container>
  );
};

export default PaymentForm;
